import * as React from 'react'
import { useTranslation } from 'react-i18next'

import PreferencesAccordion from './PreferencesAccordion'

import NotLogged from 'components/NotLogged'
import { Loading } from 'components/Icons'

import {
  getPreferences
} from 'store/reducers/preference.thunks'

import { useDispatch, useSelector } from 'react-redux'

import './styles.sass'
import { IconButton } from '@mui/material'
import { CheckCircleOutline, DoNotDisturb, VisibilityOutlined } from '@mui/icons-material'

function Preferences() {
  const { t } = useTranslation()
  const { auth, preferences, geral = {} } = useSelector((store) => store)
  const reduxDispatch = useDispatch()

  React.useEffect(() => {
    if (auth.isAuthenticated && geral.language) {
      reduxDispatch(getPreferences(geral.language))
    }
    // eslint-disable-next-line
  }, [reduxDispatch, geral.language])


  if (!auth.isAuthenticated) {
    return (
      <section>
        <NotLogged />
      </section>
    )
  }
  return (
    <section>
      <header className="pvt-content-header custom">
        <h1 className="pvt-content-title custom">{t('preferences.title')}</h1>
        <p className="pvt-content-desc custom">
          {t('preferences.content.description')}
        </p>
      </header>

      {preferences.fetching ?
        <p><Loading /> {t('yourPersonalData.loading')}</p>
        : null
      }

      {!preferences.fetching && (!preferences?.preferences || !preferences?.preferences.length) ?
        <p>{t('yourRequests.noregister')}</p>
        : null
      }

      {preferences?.preferences.map((preference, index) => (
        <article key={preference.name} className="pvt-preference custom pvt-card">
          <h4>{preference.name}</h4>
          {preference.consents.map((consent, indexChild) => (
            <PreferencesAccordion key={`${index}-${indexChild}-${consent.title}`} consent={consent} alwaysActive={consent.type === 'R'}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                {!!(consent.reason) ? <p>{consent.reason}</p> : null}
                {!!(consent.retentionDate) ? <p><span style={{ fontWeight: 700 }}>{t("date.label.retention")}</span>&nbsp;{consent.retentionDate}</p> : null}
                {(consent.userState === false && !!(consent.revokeDate)) ? <p><span style={{ fontWeight: 700 }}>{t("date.label.revoke")}</span>&nbsp;{consent.revokeDate}</p> : null}
              </div>
              {consent.audits?.length > 0 &&
                <div className="policy-section">
                  <div className="policy-header">
                    <span className="policy-title">{t('label.consent.history')}</span>
                  </div>
                  <div className="policy-list" style={{ maxHeight: 600, overflowY: 'auto' }}>
                    {consent.audits.map(audit => (
                      <div key={audit?.encryptedId} className="policy-item" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span className="policy-name">{audit?.value === "true" ? <CheckCircleOutline style={{ marginBottom: 1, color: 'green' }} /> : <DoNotDisturb style={{ marginBottom: 1, color: 'red' }} />}
                          {` - ${audit?.value === "true" ? t('label.authorized') : t('label.revoked')} ${t('label.in')} ${audit?.auditFormatted}`}</span>
                      </div>
                    ))}
                  </div>
                </div>
              }
              {consent.policies?.length > 0 &&
                <div className="policy-section">
                  <div className="policy-header">
                    <span className="policy-title">{t('label.policies')}</span>
                  </div>
                  <div className="policy-list">
                    {consent.policies.map(policy => (
                      <div key={policy.hashid} className="policy-item" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <span className="policy-name">{policy.name}</span>
                            <IconButton
                              href={policy.linkLastVersion} 
                              target="_blank"
                              rel="noopener noreferrer"
                              size="small"
                            >
                              <VisibilityOutlined fontSize="small" color="primary" />
                            </IconButton>
                        </div>
                    ))}
                  </div>
                </div>
              }
            </PreferencesAccordion>
          ))}
        </article>
      ))}
    </section>
  )
}

export default Preferences